import { MapPin } from "lucide-react";
import { Reveal } from "../components/shared";
import { SiteLayout, PageHero, CtaBand } from "../components/site";
import { CONTACT } from "../content";

const PHOTOS = [
  { id: "reception", src: "/images/practice/reception.jpg", alt: "Inner You Development reception desk", span: "md:col-span-7 md:row-span-2" },
  { id: "therapy-room", src: "/images/practice/therapy-room.jpg", alt: "Therapy room with green armchair and plants", span: "md:col-span-5" },
  { id: "counselling-room", src: "/images/practice/counselling-room.jpg", alt: "Counselling room with armchair and floor lamp", span: "md:col-span-2" },
  { id: "play-room", src: "/images/practice/play-room.jpg", alt: "Children's play room with toys and shelving", span: "md:col-span-3" },
  { id: "practice-room", src: "/images/practice-room.jpg", alt: "Practice room in Upper Mount Gravatt", span: "md:col-span-12" },
];

export default function Practice() {
  return (
    <SiteLayout testid="practice-page">
      <PageHero eyebrow="Our practice" lines={["Calm spaces.", "Room to breathe."]} sub="Come and see where you'll be welcomed in Upper Mount Gravatt.">
        <p className="mt-6 inline-flex items-start gap-2 font-jakarta text-sm text-[#4A4F45]" data-testid="practice-address"><MapPin className="w-4 h-4 mt-0.5 text-[#C59B45] shrink-0" />{CONTACT.address}</p>
      </PageHero>
      <section className="max-w-[1360px] mx-auto px-5 sm:px-10 pb-20 grid grid-cols-1 md:grid-cols-12 md:auto-rows-[260px] lg:auto-rows-[300px] gap-4 sm:gap-5" data-testid="practice-gallery">
        {PHOTOS.map((p, i) => (
          <Reveal key={p.id} delay={(i % 3) * 0.08} className={`${p.span} overflow-hidden rounded-[28px] border border-[#C59B45]/25 bg-[#EFE9DC]`}>
            <img src={p.src} alt={p.alt} loading="lazy" data-testid={`practice-photo-${p.id}`}
              className="w-full h-72 sm:h-96 md:h-full object-cover transition-transform duration-700 hover:scale-[1.03]" />
          </Reveal>
        ))}
      </section>
      <CtaBand />
    </SiteLayout>
  );
}
